import type { AgentFrame } from "./agent-types";

const parseSseEvent = (raw: string): AgentFrame | null => {
  const lines = raw.split("\n");
  const dataLines: string[] = [];
  for (const line of lines) {
    if (!line.startsWith("data:")) continue;
    const value = line.slice(5);
    dataLines.push(value.startsWith(" ") ? value.slice(1) : value);
  }
  if (dataLines.length === 0) return null;
  try {
    return JSON.parse(dataLines.join("\n")) as AgentFrame;
  } catch {
    return null;
  }
};

export async function* parseSseFrames(
  stream: ReadableStream<Uint8Array>,
  signal?: AbortSignal,
): AsyncGenerator<AgentFrame> {
  const reader = stream.getReader();
  const decoder = new TextDecoder();
  let buffer = "";
  try {
    while (true) {
      if (signal?.aborted) return;
      const { value, done } = await reader.read();
      if (done) break;
      buffer += decoder.decode(value, { stream: true });
      let boundary = buffer.indexOf("\n\n");
      while (boundary !== -1) {
        const event = buffer.slice(0, boundary);
        buffer = buffer.slice(boundary + 2);
        const frame = parseSseEvent(event);
        if (frame) yield frame;
        boundary = buffer.indexOf("\n\n");
      }
    }
    if (buffer.trim()) {
      const frame = parseSseEvent(buffer);
      if (frame) yield frame;
    }
  } finally {
    reader.releaseLock();
  }
}
